import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LanguageService } from '../../services/language.service';

/**
 * Compact language selector for the side nav. Shows a globe icon (+ the active
 * language code when expanded) and opens a menu of the available languages.
 */
@Component({
  selector: 'lib-language-switcher',
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss'
})
export class LanguageSwitcherComponent {
  /** When true, render icon-only (collapsed nav). */
  @Input() isCollapsed = false;

  protected languageService = inject(LanguageService);

  protected get currentLabel(): string {
    const code = this.languageService.current();
    return this.languageService.availableLanguages.find(l => l.code === code)?.label ?? code;
  }

  protected select(code: string): void {
    this.languageService.use(code);
  }
}
